export const kv = {
  logo: '',
  copy: '',
  circle: '',
  duration: 1000,
  logoSpeed: 100,
  copySpeed: 25,
  random: (min, max)=>{
    return Math.floor( Math.random() * (max + 1 - min) ) + min ;
  },
  init: ()=>{

    kv.logo = document.getElementById('kv_logo');
    kv.copy = document.getElementById('kv_copy');
    kv.circle = document.getElementById('kv_circle');
    kv.circle.style.setProperty('--kv-duration', kv.duration + 'ms');

    const logoPath = kv.logo.querySelectorAll('path'),
          copyPath = kv.copy.querySelectorAll('path');

    //サークル表示開始
    kv.circle.classList.add('start');

    //サークル表示終了後
    setTimeout(()=>{
      //ロゴ表示開始
      Array.prototype.slice.call(logoPath,0).forEach((elm, i) => {
        setTimeout(()=>{
          elm.classList.add('show');
        }, i * kv.logoSpeed);
      });
      //サークルの位置をランダムに移動（ゆらす）
      setInterval(()=>{
        let x = kv.random(-15, 15) + 'px',
            y = kv.random(-15, 15) + 'px';
        kv.circle.style.transform = 'translate('+ x +','+ y +')';
      }, kv.duration);
    }, kv.duration);

    //ロゴ表示終了後
    setTimeout(()=>{
      //コピー表示開始
      Array.prototype.slice.call(copyPath,0).forEach((elm, i) => {
        setTimeout(()=>{
          elm.classList.add('show');
        }, i * kv.copySpeed);
      });
    }, logoPath.length * kv.logoSpeed + kv.duration);

  }
}
